import { mapToObjectDDL } from "../../common/mapper";
import { formGroup } from "./config/formConfig";
import { INITIAL_FORM_MANDATORY, INITIAL_SAVED_ROW } from "./constant";

export const sanitizeDateTime = (raw, type = "full") => {
  const nums = raw.replace(/[^0-9]/g, "");

  let DD = nums.substring(0, 2);
  let MM = nums.substring(2, 4);
  let YYYY = nums.substring(4, 8);

  let HH = nums.substring(8, 10);
  let mm = nums.substring(10, 12);
  let ss = nums.substring(12, 14);

  if (type === "time") {
    HH = nums.substring(0, 2);
    mm = nums.substring(2, 4);
  }

  if (DD && +DD > 31) DD = "31";
  if (MM && +MM > 12) MM = "12";
  if (HH && +HH > 23) HH = "23";
  if (mm && +mm > 59) mm = "59";
  if (ss && +ss > 59) ss = "59";

  switch (type) {
    case "date":
      return [DD, MM, YYYY].filter(Boolean).join("-");
    case "time":
      return [HH, mm].filter(Boolean).join(":");
    case "full-time":
      return [HH, mm, ss].filter(Boolean).join(":");
    case "full":
    default:
      const datePart = [DD, MM, YYYY].filter(Boolean).join("-");
      const timePart = [HH, mm, ss].filter(Boolean).join(":");
      return datePart + (timePart ? " " + timePart : "");
  }
};

const setDataAndCheckIsAutoFilled = (setter, autoFilled, data) => {
  Object.keys(data).forEach((key) => {
    const value = data[key];

    setter(key, value || null);

    if (value && autoFilled) {
      autoFilled[key] = true;
    }
  });
};

export const autoPopulateCheckNosinResult = ({
  dataUnit,
  dataCustomer,
  setValueUnit,
  setValueCustomer,
  isCustomer,
  setValueCarrier,
}) => {
  const autoUnit = {};
  const autoCustomer = {};

  if (dataUnit) {
    setDataAndCheckIsAutoFilled(setValueUnit, autoUnit, {
      noPolisi: dataUnit.noPolisi,
      noMesin: dataUnit.noMesin,
      noRangka: dataUnit.noRangka,
      kodeVarian: mapToObjectDDL(
        dataUnit.variantDTO?.kodeVariant,
        dataUnit.variantDTO?.kodeVariant
      ),
      namaVarian: dataUnit.variantDTO?.namaVariant,
      tahunMotor: dataUnit.tahunMotor,
    });
  } else {
    setDataAndCheckIsAutoFilled(setValueUnit, autoUnit, {
      noPolisi: null,
      noMesin: null,
      noRangka: null,
      kodeVarian: null,
      namaVarian: null,
      tahunMotor: null,
    });
  }

  if (!dataCustomer) {
    return { unit: autoUnit, customer: autoCustomer };
  }

  const { dataCustomer: cust, dataTambahan, dataMember } = dataCustomer;

  if (!dataUnit) {
    setDataAndCheckIsAutoFilled(setValueUnit, autoUnit, {
      noPolisi: null,
      noMesin: null,
      noRangka: null,
      kodeVarian: null,
      namaVarian: null,
      tahunMotor: null,
    });
    setDataAndCheckIsAutoFilled(setValueCustomer, null, {
      name: null,
      nik: null,
      kkNumber: null,
      npwp: null,
      hpNumber1: null,
      hpNumber2: null,
      email: null,
      address: null,
      province: null,
      kabkot: null,
      kecamatan: null,
      kelurahan: null,
      zipCode: null,
      gender: null,
      religion: null,
      job1: null,
      job2: null,
      facebook: null,
      instagram: null,
      linkedin: null,
      x: null,
      tiktok: null,
      memberId: null,
      memberLevel: null,
      loyaltyLevel: null,
    });

    if (isCustomer) {
      setDataAndCheckIsAutoFilled(setValueCarrier, null, {
        name: null,
        nik: null,
        kkNumber: null,
        npwp: null,
        hpNumber1: null,
        hpNumber2: null,
        email: null,
        address: null,
        province: null,
        kabkot: null,
        kecamatan: null,
        kelurahan: null,
        zipCode: null,
        gender: null,
        religion: null,
        job1: null,
        job2: null,
        facebook: null,
        instagram: null,
        linkedin: null,
        x: null,
        tiktok: null,
        memberId: null,
        memberLevel: null,
        loyaltyLevel: null,
      });
    }

    return { unit: autoUnit, customer: autoCustomer };
  }

  setDataAndCheckIsAutoFilled(setValueCustomer, autoCustomer, {
    name: cust?.customerName,
    nik: cust?.nik,
    kkNumber: cust?.kkNumber,
    npwp: cust?.npwp,
    hpNumber1: dataTambahan?.nomorHP1,
    hpNumber2: dataTambahan?.nomorHP2,
    email: dataTambahan?.email,
    address: cust?.address,

    province: cust?.dataProvince?.id
      ? mapToObjectDDL(cust?.dataProvince?.provinceName, cust?.dataProvince?.id)
      : null,
    kabkot: cust?.dataKabKot?.kabKotId
      ? mapToObjectDDL(cust?.dataKabKot?.kabKotName, cust?.dataKabKot?.kabKotId)
      : null,
    kecamatan: cust?.dataKecamatan?.id
      ? mapToObjectDDL(
          cust?.dataKecamatan?.kecamatanName,
          cust?.dataKecamatan?.id
        )
      : null,
    kelurahan: cust?.dataKelurahan?.id
      ? mapToObjectDDL(
          cust?.dataKelurahan?.kelurahanname,
          cust?.dataKelurahan?.id
        )
      : null,
    zipCode: cust?.dataKelurahan?.zipcode
      ? mapToObjectDDL(
          cust?.dataKelurahan?.zipcode,
          cust?.dataKelurahan?.zipcode
        )
      : null,

    gender: cust?.dataGender?.key
      ? mapToObjectDDL(cust?.dataGender?.value, cust?.dataGender?.key)
      : null,
    religion: cust?.dataAgama?.key
      ? mapToObjectDDL(cust?.dataAgama?.value, cust?.dataAgama?.key)
      : null,

    job1: cust?.pekerjaan1?.key
      ? mapToObjectDDL(cust?.pekerjaan1?.value, cust?.pekerjaan1?.key)
      : null,
    job2: cust?.pekerjaan2?.key
      ? mapToObjectDDL(cust?.pekerjaan2?.value, cust?.pekerjaan2?.key)
      : null,
    facebook: dataTambahan?.facebookAccount,
    instagram: dataTambahan?.instagramAccount,
    linkedin: dataTambahan?.linkedin,
    x: dataTambahan?.xAccount,
    tiktok: dataTambahan?.tiktokAccount,

    memberId: dataMember?.kodeMember,
    memberLevel: dataMember?.memberLevel,
    loyaltyLevel: dataMember?.loyaltyLevel,
  });

  return {
    unit: autoUnit,
    customer: autoCustomer,
  };
};

export const constructGetDataModalCustomer = (item) => {
  return {
    name: item?.name,
    hpNumber1: item?.noTelepon,
    hpNumber2: item?.noTelepon2,
    nik: item?.nik,
    tanggalLahir: item?.tanggalLahir,
    email: item?.email,
    npwp: item?.npwp,
    address: item?.alamat,
    kkNumber: item?.kkNumber,
    province: mapToObjectDDL(
      item?.dataProvince?.provinceName,
      item?.dataProvince?.id
    ),
    kabkot: mapToObjectDDL(
      item?.dataKabKot?.kabKotName,
      item?.dataKabKot?.kabKotId
    ),
    kecamatan: mapToObjectDDL(
      item?.dataKecamatan?.kecamatanName,
      item?.dataKecamatan?.id
    ),
    kelurahan: mapToObjectDDL(
      item?.dataKelurahan?.kelurahanname,
      item?.dataKelurahan?.id
    ),
    zipCode: mapToObjectDDL(
      item?.dataKelurahan?.zipcode,
      item?.dataKelurahan?.zipcode
    ),
    gender: mapToObjectDDL(item?.gender?.value, item?.gender?.key),
    job1: mapToObjectDDL(item?.job1?.value, item?.job1?.key),
    job2: mapToObjectDDL(item?.job2?.value, item?.job2?.key),
    religion: mapToObjectDDL(item?.religion?.value, item?.religion?.key),
    memberId: item?.memberId,
    memberLevel: item?.memberLevel,
    loyaltyLevel: item?.loyaltyLevel,
    facebook: item?.facebook,
    instagram: item?.instagram,
    linkedin: item?.linkedin,
    x: item?.x,
    tiktok: item?.tiktok,
    hobby: mapToObjectDDL(item?.hobby?.[0]?.value, item?.hobby?.[0]?.key),
    interest: mapToObjectDDL(
      item?.interest?.[0]?.value,
      item?.interest?.[0]?.key
    ),
  };
};

export const autoPopulateSelectBooking = ({ data, setValue }) => {
  setValue("name", data.name);
  setValue("nik", data.nik);
  setValue("kkNumber", data.kkNumber);
  setValue("npwp", data.npwp);
  setValue("hpNumber1", data.hpNumber1);
  setValue("hpNumber2", data.hpNumber2);
  setValue("email", data.email);
  setValue("address", data.address);
  setValue("province", data.province);
  setValue("kabkot", data.kabkot);
  setValue("kecamatan", data.kecamatan);
  setValue("kelurahan", data.kelurahan);
  setValue("zipCode", data.zipCode);

  setValue("gender", data.gender);
  setValue("religion", data.religion);

  setValue("job1", data.job1);
  setValue("job2", data.job2);

  setValue("facebook", data.facebook);
  setValue("instagram", data.instagram);
  setValue("linkedin", data.linkedin);
  setValue("x", data.x);
  setValue("tiktok", data.tiktok);

  setValue("memberId", data.memberId);
  setValue("memberLevel", data.memberLevel);
  setValue("loyaltyLevel", data.loyaltyLevel);
};

function validateEmptyValue(key, val, data) {
  if (val.mandatory && (!data?.[key] || data[key] === "")) {
    return "Field belum diisi";
  }

  return null;
}

const getDataFromGroup = () => {
  const {
    dataUnit,
    dataPemilik,
    dataPembawa,
    dataAnalisa,
    dataTransaksi,
    dataTambahan,
    dataKeterangan,
    ...rest
  } = formGroup;
  return {
    fgUnit: dataUnit,
    fgPemilik: dataPemilik,
    fgPembawa: dataPembawa,
    fgAnalisa: dataAnalisa,
    fgTransaction: dataTransaksi,
    fgTambahan: dataTambahan,
    fgKeterangan: dataKeterangan,
    ...rest,
  };
};

export const validate = (data, fjbSource) => {
  const {
    fgUnit,
    fgPemilik,
    fgPembawa,
    fgAnalisa,
    fgTransaction,
    fgTambahan,
    fgKeterangan,
    ...fgHeader
  } = getDataFromGroup();

  const {
    dataUnit,
    dataPemilik,
    dataPembawa,
    analisa,
    dataTransaksi,
    dataTambahan,
    dataKeterangan,
    ...headerData
  } = data;

  let newErrors = {
    dataUnit: {},
    dataPemilik: {},
    dataPembawa: {},
    dataAnalisa: {},
    dataTransaksi: {},
    dataTambahan: {},
    dataKeterangan: {},
  };

  const isSO = fjbSource === "STOCK_OPNAME"; //harusnya cek sourcenya dari so apa bukan

  for (const [key, val] of Object.entries(fgHeader)) {
    const message = validateEmptyValue(key, val, headerData);
    if (message) {
      newErrors[key] = message;
    }
  }

  for (const [key, val] of Object.entries(fgPembawa)) {
    const message = validateEmptyValue(key, val, dataPembawa);
    if (message) {
      newErrors["dataPembawa"] = {
        ...newErrors["dataPembawa"],
        [key]: message,
      };
    }
  }

  if (dataPembawa.pemilik) {
    if (!dataPemilik?.perusahaan && !dataPembawa?.nik) {
      newErrors["dataPembawa"] = {
        ...newErrors["dataPembawa"],
        nik: "Field belum diisi",
      };
    }
  } else {
    if (!dataPemilik?.perusahaan && !dataPembawa?.nik) {
      newErrors["dataPembawa"] = {
        ...newErrors["dataPembawa"],
        nik: "Field belum diisi",
      };
    }
  }

  for (const [key, val] of Object.entries(fgKeterangan)) {
    const message = validateEmptyValue(key, val, dataKeterangan);
    if (message) {
      newErrors["dataKeterangan"] = {
        ...newErrors["dataKeterangan"],
        [key]: message,
      };
    }
  }

  const rulesDataTambahan =
    headerData?.kategoriFakturJualBengkel === "DIRECT_SALES" || isSO
      ? { sa: INITIAL_FORM_MANDATORY }
      : fgTambahan;

  for (const [key, val] of Object.entries(rulesDataTambahan)) {
    const message = validateEmptyValue(key, val, dataTambahan);
    if (message) {
      newErrors["dataTambahan"] = {
        ...newErrors["dataTambahan"],
        [key]: message,
      };
    }
  }
  if (!isSO && headerData?.kategoriFakturJualBengkel !== "DIRECT_SALES") {
    for (const [key, val] of Object.entries(fgUnit)) {
      const message = validateEmptyValue(key, val, dataUnit);
      if (message) {
        newErrors["dataUnit"] = {
          ...newErrors["dataUnit"],
          [key]: message,
        };
      }
    }

    for (const [key, val] of Object.entries(fgPemilik)) {
      const message = validateEmptyValue(key, val, dataPemilik);
      if (message) {
        newErrors["dataPemilik"] = {
          ...newErrors["dataPemilik"],
          [key]: message,
        };
      }
    }

    if (!dataPemilik?.perusahaan && !dataPemilik?.nik) {
      newErrors["dataPemilik"] = {
        ...newErrors["dataPemilik"],
        nik: "Field belum diisi",
      };
    }

    for (const [key, val] of Object.entries(fgAnalisa)) {
      const message = validateEmptyValue(key, val, analisa);
      if (message) {
        newErrors["dataAnalisa"] = {
          ...newErrors["dataAnalisa"],
          [key]: message,
        };
      }
    }
  }

  return newErrors;
};

const parseDataTransaksi = (data) => {
  return {
    kodeLocator: data.locator?.value || null,
    packageId: data?.paket?.value || null,
    tipePromo: data?.tipePromo || null,
    serviceItem: data?.dataJob?.map((item) => ({
      kodeJasa: item.kodeJasa?.value,
      namaJasa: item?.namaJasa?.label,
      serviceCategoryId: item?.serviceCategory?.value,
      serviceCategoryName: item?.serviceCategory?.label,
      hargaSatuanSistem: item?.hargaSatuanSistem,
      hargaDiberikan: Number(item?.hargaDiberikan),
      diskonSistem: item?.diskonSistem,
      diskonDiberikan: Number(item?.diskonDiberikan),
      diskonSistemCurrency: item?.diskonSistemCurrency,
      diskonDiberikanCurrency: Number(item?.diskonDiberikanCurrency),
      estimasiWaktu: item?.estimasiWaktu,
      totalHarga: item?.totalHarga,
    })),
    partItem:
      data?.dataPartNonQR?.length > 0
        ? data?.dataPartNonQR?.map((item) => ({
            kodePart: item?.kodePart?.value,
            namaPart: item?.namaPart?.label,
            qtyPart: item?.qtyPart || 1,
            qtyStock: item?.qtyStock,
            hargaSatuanSistem: item?.hargaSatuanSistem,
            hargaDiberikan: Number(item?.hargaDiberikan),
            diskonSistem: item?.diskonSistem,
            diskonDiberikan: Number(item?.diskonDiberikan),
            diskonSistemCurrency: item?.diskonSistemCurrency,
            diskonDiberikanCurrency: Number(item?.diskonDiberikanCurrency),
            totalHarga: item?.totalHarga,
          }))
        : null,
    partItemQr:
      data?.dataPartQR?.length > 0
        ? data?.dataPartQR?.map((item) => ({
            kodePart: item?.kodePart?.value,
            namaPart: item?.namaPart?.label,
            qtyPart: item?.qtyPart,
            qtyStock: item?.qtyStock,
            partQrCode: item?.qrCode,
            hargaSatuanSistem: item?.hargaSatuanSistem,
            hargaDiberikan: Number(item?.hargaDiberikan),
            diskonSistem: item?.diskonSistem,
            diskonDiberikan: Number(item?.diskonDiberikan),
            diskonSistemCurrency: item?.diskonSistemCurrency,
            diskonDiberikanCurrency: Number(item?.diskonDiberikanCurrency),
            totalHarga: item?.totalHarga,
          }))
        : null,
    promoId: data?.promoId,
    bankId: data?.kodeBank?.value,
    namaPromo: data?.namaPromo?.label || null,
    kodeVoucher: data?.kodeVoucher,
    tipePembayaran: data?.tipePembayaran,
    tipePembayaranNonTunai: data?.tipePembayaranNonTunai?.value || null,
    totalSebelumDiskonJasa: data?.totalJasaSebelumDiskon,
    totalDiskonJasa: data?.totalJasaDiskon,
    totalSebelumDiskonPart: data?.totalPartSebelumDiskon,
    totalDiskonPart: data?.totalPartDiskon,
    titipanHotline: data?.totalTitipanHotlin,
  };
};

const countTotalFrt = (data) => {
  if (!data) return;
  const num = data.split(":");
  return Number(num[0]) * 60 + Number(num[1]);
};

const parseDataTambahan = (data) => {
  const {
    jenisPit,
    asalUnitEntry,
    mekanik,
    finalCheck,
    adminFjb,
    sa,
    waktuPKB,
    totalFrt,
    namaMekanik,
    ...rest
  } = data;
  return {
    ...rest,
    totalFrt: countTotalFrt(totalFrt),
    waktuPkb: waktuPKB,
    jenisPit: jenisPit?.value || null,
    asalUnitEntry: asalUnitEntry?.value || null,
    mekanik: mekanik?.value || null,
    finalCheck: finalCheck?.value || null,
    sa: sa?.value || null,
    adminFjb: adminFjb?.value,
  };
};

const parseDataPersonal = (data, type) => {
  const {
    province,
    kecamatan,
    kelurahan,
    kabkot,
    perusahaan,
    isCompany,
    isBuyer,
    isMakelarProfessional,
    memberId,
    hpNumber1,
    hpNumber2,
    address,
    gender,
    zipCode,
    job1,
    job2,
    religion,
    hobby,
    interest,
    loyaltyLevel,
    npwp,
    name,
    kkNumber,
    zipcode,
    jenisProspectH1,
    jenisProspectH23,
    ...rest
  } = data;

  let check = null;
  if (type === "dataPemilik") {
    check = { perusahaan: !!isCompany };
  } else if (type === "dataPembawa") {
    check = { pemilik: !!isBuyer };
  }

  return {
    ...rest,
    ...(check ? check : {}),
    noKK: kkNumber,
    nama: name,
    npwp: npwp || null,
    loyaltyLvl: loyaltyLevel,
    customerId: memberId,
    noHp1: hpNumber1,
    noHp2: hpNumber2,
    alamat: address,
    jenisKelamin: gender?.value || null,
    kodePos: zipCode?.value || null,
    provinsi: province?.value || null,
    kota: kabkot?.value || null,
    kecamatan: kecamatan?.value || null,
    kelurahan: kelurahan?.value || null,
    pekerjaan1: job1?.value || null,
    pekerjaan2: job2?.value || null,
    agama: religion?.value || null,
    hobby: hobby?.value ? [hobby?.value] : null,
    interest: interest?.value ? [interest?.value] : null,
  };
};

const parseDataUnit = (data) => {
  const {
    kodeVarian,
    namaVarian,
    tahunMotor,
    informasiBensin,
    kmTerakhir,
    ...rest
  } = data;
  return {
    ...rest,
    informasiBensin: Number(informasiBensin),
    kmTerakhir: Number(kmTerakhir),
    tahunMotor: Number(tahunMotor),
    kodeVariant: kodeVarian?.value,
    namaVariant: namaVarian,
  };
};

const checkIsEmpty = (data) => {
  return Object.values(data)?.every((item) => !item);
};

export const constructPayloadSubmitNOS = (data) => {
  const {
    noFakturJualBengkel,
    tanggalFakturJualBengkel,
    kodeCabang,
    noProspect,
    noBooking,
    noHotline,
    tipeFjb,
    kategoriFakturJualBengkel,
    jenisProspect,
    mekanikSebelumnya,
    claimNo,
  } = data;

  const dataUnit = parseDataUnit(data.dataUnit);
  const dataPemilik = parseDataPersonal(data.dataPemilik, "dataPemilik");
  const dataPembawa = parseDataPersonal(data.dataPembawa, "dataPembawa");
  const analisa = data.dataAnalisa;
  const dataTambahan = parseDataTambahan(data.dataTambahan);
  const keterangan = data.dataKeterangan;
  const dataTransaksi = parseDataTransaksi(data.dataTransaksi);

  const isEmptyDataPemilik = checkIsEmpty(dataPemilik);
  const isEmptyDataUnit = checkIsEmpty(dataUnit);
  const isEmptyDataAnalisa = checkIsEmpty(analisa);

  return {
    noFakturJualBengkel,
    tanggalFakturJualBengkel,
    kategoriFakturJualBengkel: kategoriFakturJualBengkel?.value,
    mekanikSebelumnya: mekanikSebelumnya?.value || null,
    jenisProspect: jenisProspect || "NEW",
    statusFakturJualBengkel: "DRAFT",
    kodeCabang: kodeCabang?.value,
    noProspect: noProspect || null,
    noBooking: noBooking || null,
    noHotline: noHotline || null,
    noClaim: claimNo || null,
    tipeFakturJualBengkel: tipeFjb?.value,
    dataUnit: !isEmptyDataUnit ? dataUnit : null,
    dataPembawa,
    dataPemilik: !isEmptyDataPemilik ? dataPemilik : null,
    analisa: !isEmptyDataAnalisa ? analisa : null,
    dataTambahan,
    keterangan,
    dataTransaksi,
    action: "CONFIRM_ORDER",
  };
};

export const calculatePercentage = (value, total) => {
  if (total === 0) return 0;
  return Math.round((value / total) * 100 * 100) / 100;
};

export const calculatePercentAmount = (value, total) => {
  if (total === 0) return 0;
  return Math.round((value / 100) * total);
};

export const constructDataFromPackage = (data) => {
  const { partQR, part, service } = data;

  const resultQR =
    partQR?.map((item) => ({
      kodePart: mapToObjectDDL(item.kodePart, item.kodePart),
      namaPart: mapToObjectDDL(item.partName, item.kodePart),
      qtyPart: item.partQty,
      qtyStock: item.stockQty || 0,
      qrCode: null,
      hargaSatuanSistem: item?.price,
      hargaDiberikan: item?.price,
      diskonSistem: 0,
      diskonDiberikan: 0,
      diskonSistemCurrency: 0,
      diskonDiberikanCurrency: 0,
      totalHarga: item?.price * item.partQty,
      dariPackage: true,
      ...INITIAL_SAVED_ROW,
      isSaved: true,
    })) || [];

  const resultPart =
    part?.map((item) => ({
      kodePart: mapToObjectDDL(item.kodePart, item.kodePart),
      namaPart: mapToObjectDDL(item.partName, item.kodePart),
      qtyPart: item.partQty,
      qtyStock: item.stockQty || 0,
      hargaSatuanSistem: item?.price,
      hargaDiberikan: item?.price,
      diskonSistem: 0,
      diskonDiberikan: 0,
      diskonSistemCurrency: 0,
      diskonDiberikanCurrency: 0,
      totalHarga: item?.price * item.partQty,
      dariPackage: true,
      ...INITIAL_SAVED_ROW,
      isSaved: true,
    })) || [];

  const resultService =
    service?.map((item) => ({
      kodeJasa: mapToObjectDDL(item.serviceCode, item.serviceCode),
      namaJasa: mapToObjectDDL(item.serviceName, item.serviceCode),
      serviceCategory: mapToObjectDDL(
        item.serviceCategory?.value,
        item.serviceCategory?.key
      ),
      hargaSatuanSistem: item.price,
      hargaDiberikan: item.price,
      diskonSistem: 0,
      diskonDiberikan: 0,
      diskonSistemCurrency: 0,
      diskonDiberikanCurrency: 0,
      estimasiWaktu: item.estimationTime,
      totalHarga: item.price,
      dariPackage: true,
      ...INITIAL_SAVED_ROW,
      isSaved: true,
    })) || [];

  return { resultQR, resultPart, resultService };
};

const applyAllPromoToItem = (item, unit, value) => {
  const qty = Number(item.qtyPart || 1);
  const harga = Number(item?.hargaDiberikan);

  if (unit === "PERCENTAGE") {
    const discount = calculatePercentAmount(value, harga);

    return {
      ...item,
      diskonSistem: value,
      diskonDiberikan: value,
      diskonSistemCurrency: 0,
      diskonDiberikanCurrency: discount,
      totalHarga: discount > harga * qty ? 0 : harga * qty - discount,
    };
  }

  return {
    ...item,
    diskonSistem: 0,
    diskonDiberikan: calculatePercentage(value, harga),
    diskonSistemCurrency: value,
    diskonDiberikanCurrency: value,
    totalHarga: value > harga * qty ? 0 : harga * qty - value,
  };
};

const applyPromo = (list = [], promoList, type, promo) => {
  let result = [];
  let matchData = [];
  if (!list || list?.length === 0) {
    return {
      result: [],
      matchData: [],
    };
  }
  result = list?.map((item) => {
    let match = null;
    if (type === "part") {
      match = promoList.find((p) => p.kodePart === item.kodePart?.value);
    } else {
      match = promoList.find((p) => p.serviceCode === item.kodeJasa?.value);
    }

    if (!match) return item;
    matchData.push(item);

    const tempTotalHarga =
      Number(item.hargaDiberikan) * Number(item.qtyPart || 1);

    if (match.unit === "PERCENTAGE") {
      const nominalDiskon = calculatePercentAmount(
        match.discountValue,
        item.hargaDiberikan
      );

      return {
        ...item,
        diskonSistem: match.discountValue,
        diskonDiberikan: match.discountValue,
        diskonSistemCurrency: 0,
        diskonDiberikanCurrency: nominalDiskon,
        totalHarga:
          nominalDiskon > tempTotalHarga ? 0 : tempTotalHarga - nominalDiskon,
      };
    }

    return {
      ...item,
      diskonSistem: 0,
      diskonDiberikan: calculatePercentage(
        match.discountValue,
        item.hargaDiberikan
      ),
      diskonSistemCurrency: match.discountValue,
      diskonDiberikanCurrency: match.discountValue,
      totalHarga:
        match.discountValue > tempTotalHarga
          ? 0
          : tempTotalHarga - match.discountValue,
    };
  });

  if (type === "part" && promo?.promoAllPart) {
    result = result.map((item) =>
      applyAllPromoToItem(item, promo.promoAllPartUnit, promo.promoAllPartValue)
    );
  }

  if (type === "job" && promo?.promoAllJob) {
    result = result.map((item) =>
      applyAllPromoToItem(item, promo.promoAllJobUnit, promo.promoAllJobValue)
    );
  }

  return {
    result,
    matchData,
  };
};

export const calculateAndSetPromo = ({ promo, onSetState, setLocalState }) => {
  const { job: promoJob, part: promoPart } = promo || { job: [], part: [] };
  const promoQr = [];
  const promoNonQr = [];

  const jobPromo = promoJob.map((item) => ({
    discountValue: item.discountValue,
    unit: item.unit,
    serviceCode: item?.service?.serviceCode,
  }));

  promoPart.forEach((item) => {
    const data = {
      discountValue: item.discountValue,
      unit: item.unit,
      kodePart: item?.part?.kodePart,
    };
    item.part?.qrCode ? promoQr.push(data) : promoNonQr.push(data);
  });

  onSetState((prev) => {
    const { result: dataPartNonQR, matchData: matchNonQr } =
      applyPromo(
        prev.data.dataTransaksi.dataPartNonQR,
        promoNonQr,
        "part",
        promo
      ) || [];

    const { result: dataPartQR, matchData: matchQr } =
      applyPromo(prev.data.dataTransaksi.dataPartQR, promoQr, "part", promo) ||
      [];

    const combined = [...dataPartNonQR, ...dataPartQR];

    if (matchNonQr.length > 0) {
      setLocalState((prev) => ({
        ...prev,
        backupPromo: {
          ...prev.backupPromo,
          tableNonQr: matchNonQr,
        },
      }));
    }
    if (matchQr.length > 0) {
      setLocalState((prev) => ({
        ...prev,
        backupPromo: {
          ...prev.backupPromo,
          tableQr: matchQr,
        },
      }));
    }

    const { result: dataJob, matchData } =
      applyPromo(prev.data.dataTransaksi.dataJob, jobPromo, "job", promo) || [];

    if (matchData.length > 0) {
      setLocalState((prev) => ({
        ...prev,
        tableJasa: {
          ...prev.backupPromo,
          tableQr: matchData,
        },
      }));
    }

    return {
      ...prev,
      data: {
        ...prev.data,
        dataTransaksi: {
          ...prev.data.dataTransaksi,
          dataPartNonQR,
          dataPartQR,
          totalPartSebelumDiskon: countBeforeDiscount(combined, "part"),
          totalPartDiskon: countDiscount(combined),
          totalPartSesudahDiskon: countAfterDiscount(combined),
          dataJob,
          totalJasaSebelumDiskon: countBeforeDiscount(dataJob),
          totalJasaDiskon: countDiscount(dataJob),
          totalJasaSesudahDiskon: countAfterDiscount(dataJob),
        },
      },
    };
  });
};

export const countBeforeDiscount = (data, type) => {
  return data.reduce(
    (prev, curr) => {
      const price = curr.hargaDiberikan === null ? curr.hargaSatuanSistem : curr.hargaDiberikan;
      return type === "part"
        ? prev + Number(price) * Number(curr?.qtyPart)
        : prev + Number(price)
    },
    0
  );
};
export const countDiscount = (data) => {
  return data.reduce(
    (prev, curr) => prev + Number(curr?.diskonDiberikanCurrency),
    0
  );
};
export const countAfterDiscount = (data) => {
  return data.reduce((prev, curr) => prev + Number(curr?.totalHarga), 0);
};
export const countEstimateTime = (data) => {
  return data.reduce((prev, curr) => prev + Number(curr?.estimasiWaktu), 0);
};
